<script>
    export let user={}
    import ProjectSelect from '../Components/ProjectSelect.svelte';
    import Filter from './Filter.svelte';
    import {onMount,onDestroy} from 'svelte';
    let statistic      = {};
    let statistics     = []
    let filter         = {}
    let filterExpanded = false;
    import {apiUrl} from '../config.svelte';
    import {Button,Table} from 'sveltestrap';
    let loading=false;
    let data    = []
    let columns = []
    let sum_row = []
    let executed={project:undefined,statistic:undefined}
    function isEmpty(obj) {
		return Object.keys(obj).length === 0;
    }
    let dataSorted=undefined;



    onMount(()=>{
        let allowed=['yarik','ms','nl']
        if(!user || user&& !allowed.includes(user.UserID.toLowerCase()))
            window.location="/"
        loadStatistics()
    })

    function sort(field){
        
        if(dataSorted==field){
            dataSorted=undefined;
            let srtFunc=(a,b)=>{
                if ( a[field] < b[field] ){
                    return 1;
                }
                if ( a[field] > b[field] ){
                    return -1;
                }
                return 0;
            }
            data.sort(srtFunc)
        }else{
            dataSorted=field;
            let srtFunc=(a,b)=>{
                if ( a[field] < b[field] ){
                    return -1;
                }
                if ( a[field] > b[field] ){
                    return 1;
                }
                return 0;
            }
            data.sort(srtFunc)
        }
        data=data
    }

    function loadStatistics(){
        statistics     = []
        fetch(apiUrl+"coaching",{
            credentials:'include',
            method:"POST",
            body:JSON.stringify({method:"statistics"}),
            cors:'no-cors'
        })
        .then(x=>x.json())
        .then(x=>{
            if(x.result){
                statistics     = x.data;
                statistic      = {}
                filterExpanded = false;
            }else{
                filterExpanded = false;
                statistics     = []
                statistic      = {}
            }
        })
        .catch(()=>{
            filterExpanded = false;
            statistics     = []
            statistic      = {}
        })
    }

    function execStat(){
        executed.statistic=statistic
        columns = []
        data    = []
        sum_row = undefined
        filterExpanded=false;
        loading=true;
        fetch(apiUrl+"coaching",{
            credentials:'include',
            method:"POST",
            body:JSON.stringify({method:statistic.name,filter:filter}),
            cors:'no-cors'
        })
        .then(x=>x.json())
        .then(x=>{
            loading=false;
            if(x.result){
                data    = x.data;
                columns = x.columns
                sum_row = x.sum
            }else{
                columns = []
                data    = []
                sum_row = undefined
            }
        })
        .catch(()=>{
            loading = false;
            columns = []
            data    = []
            sum_row = undefined
        })
    }
    function excel(){
        exportExcelReport("coaching",executed.statistic)
    }

</script>

<div style="height:calc(100% - 40px)">
    <div style="position:absolute;height:100%;width:300px;padding:2px;box-shadow: 0px 0px 2px grey;">
        отчеты
        {#each statistics as stat}
            <Button block outline color={stat.global?"dark":"success"} on:click={()=>{statistic=stat}}>{stat.name}</Button>
        {/each}
    </div>
    <div style="position:absolute;left:300px;height:100%;width:calc(100% - 300px)">
        <div style="width:calc(100% - 140px)">
            <Filter bind:statistic bind:expanded={filterExpanded} on:change={(e)=>{filter=e.detail.filter}}/>
        </div>
        <Button style="position:absolute;right:100px;top:2px;padding:0px" outline color="dark" on:click={()=>{excel()}}>
            <img src="/img/excel-icon.png" alt="to-excel" style="width:35px;height:35px;"/>
        </Button>
        <Button style="position:absolute;right:2px;top:2px;" outline color="dark" on:click={()=>{execStat()}} disabled={!(!isEmpty(statistic))}>Показать</Button>
        <div style="width:100%;top:61px;height:calc(100% - 62px);overflow:auto;" id="content">
            {#if loading}
                <img src="/img/load.gif" alt="loading..."/>
            {:else}
                <Table bordered>
                    {#if columns}
                        <thead>
                            <tr>
                                {#each columns as column}
                                    <th style="cursor:pointer;background-color:rgb(202, 247, 255)" on:click={()=>{sort(column)}}>
                                        {column}
                                    </th>
                                {/each}
                            </tr>
                        </thead>
                    {/if}
                    {#if data}
                        <tbody>
                            {#each data as row}
                                <tr>
                                    {#each columns as column}
                                        {#if row[column] == undefined}
                                            <td></td>
                                        {:else}
                                            <td>{typeof row[column] ==='number' ? (row[column]).toString().replace('.',',') : (row[column]).toString()}</td>
                                        {/if}
                                    {/each}
                                </tr>
                            {/each}
                        </tbody>
                        {#if sum_row && sum_row!=null}
                            <tr style="font-weight:bold">
                                {#each columns as column}
                                    {#if sum_row[column] == undefined}
                                        <td></td>
                                    {:else}
                                        <td>{typeof sum_row[column] ==='number' ? (sum_row[column]).toString().replace('.',',') : (sum_row[column]).toString()}</td>
                                    {/if}
                                {/each}
                            </tr>
                        {/if}
                    {/if}
                    
                </Table>
            {/if}
        </div>
    </div>
</div>  